import { Component, Injector, Input, OnDestroy, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Subscription } from "rxjs";

import { RunInstructionsAction } from "../../+state/blocks/blocks.actions";
import { ISurveyButton } from "../../../models/survey/ISurveyContent";
import { BaseElement } from "../../base-element.abstract";
import { selectResponsesState, selectResponseEntities } from "../../+state/selectors";
import { SurveyResponse } from "@clients/member-direct/surveys";
import { Dictionary } from "@ngrx/entity/src/models";
import { filter, map } from "rxjs/operators";
import { get, some as _some } from "lodash";
import { ISurveyResponse } from "../../../models/survey-responses/SurveyResponse.interface";

interface SelectResponseI {
	selectIds: string[] | number[];
	selectEntities: Dictionary<SurveyResponse>;
}

@Component({
	selector: "surveys-element-button",
	templateUrl: "./element-button.component.html",
	styleUrls: ["./element-button.component.scss"],
})
export class ElementButtonComponent
	extends BaseElement
	implements OnInit, OnDestroy {
	@Input()
	public element!: ISurveyButton; // Ensure proper typing

	public disabled = false;
	public classes: string | string[] = "";
	private subscription!: Subscription;

	constructor(injector: Injector, protected store: Store) {
		super(injector);
	}

	ngOnInit(): void {
		/**
		 * DGTL-310: Check if the button should be disabled when the question in instructions are not answered
		 * This code is apply for the instructions with when is array
		 */

		const hasMatchAll = this.hasMatchAllInstructions();
		
		if (hasMatchAll) {
			this.subscription = this.store
				.pipe(
					select(selectResponseEntities),
					map((responseEntities) => this.checkDisabledForMatchAll(responseEntities)),
					filter((result) => result !== this.disabled)
				)
				.subscribe((result) => {
					this.disabled = result;
				});
		} else {
			this.subscription = this.store
				.pipe(
					select(selectResponsesState),
					map((selectResponses) => this.checkDisabled(selectResponses.ids)),
					filter((result) => result !== this.disabled)
				)
				.subscribe((result) => {
					this.disabled = result;
				});
		}


		const classes = get(this.element, 'config.layout.classes');
		this.classes = classes ? classes : '';
	}

	private hasMatchAllInstructions(): boolean {
		return this.element.instructions?.some(
			(instruction) => Array.isArray(instruction.when) && 
				instruction.when.some((item: any) => item.match === 'all')
		) || false;
	}


	private checkDisabledForMatchAll(responseEntities: Dictionary<ISurveyResponse>): boolean {
		if (this.element.instructions && this.element.instructions.length) {
			const firstWhen = this.element.instructions[0].when;
			if (Array.isArray(firstWhen)) {
				return !firstWhen.every((item) => {
					const questionId = item.prop;
					return _some(responseEntities, (response) => response.questionId === questionId);
				});
			}
		}
		return false;
	}

	private checkDisabled(responsesIds: any[]): boolean {
		if (this.element.instructions && this.element.instructions.length) {
			const firstWhen = this.element.instructions[0].when;
			if (Array.isArray(firstWhen)) {
				return !firstWhen.every((item) => responsesIds.includes(item.prop));
			}
		}
		return false;
	}

	public execute() {
		this.store.dispatch(new RunInstructionsAction(this.element));
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
